// apps/web/src/components/painel/home/tag-categoria.tsx — Fase 17.8, Plano 07 (D-09; UI-SPEC U-12).
// Tag de categoria de uma linha de "Precisa de você": o TEXTO é o sinal (a cor só reforça e nunca indica urgência). Cada tag
// lê o matiz de --tag-{id} e a tinta de --tag-{id}-ink (painel-tokens.css); nenhum matiz solto entra no componente.
import type { CSSProperties, ReactElement } from 'react';
import type { TagCategoria as IdTag } from '@pieltec/contracts';
import '../../../styles/painel-home.css';

/** Texto de cada tag (U-12). Nova categoria exige linha na tabela da U-12 e entrada aqui, nunca matiz solto. */
export const TEXTO_DA_TAG: Readonly<Record<IdTag, string>> = {
  prazo: 'Prazo',
  omie: 'Omie',
  financeiro: 'Financeiro',
  parado: 'Parado',
  pesagem: 'Pesagem',
  fiscal: 'Fiscal',
  capacidade: 'Capacidade',
  estoque: 'Estoque',
  po: 'Pó',
  compra: 'Compra',
  aprovar: 'Aprovar',
  faturar: 'Faturar',
  estorno: 'Estorno',
  expedicao: 'Expedição',
  nc: 'NC',
  retrabalho: 'Retrabalho',
  conferir: 'Conferir',
};

export interface TagCategoriaProps {
  readonly tag: IdTag;
}

export function TagCategoria({ tag }: TagCategoriaProps): ReactElement {
  const estilo = { '--cor-tag': `var(--tag-${tag})`, '--tinta-tag': `var(--tag-${tag}-ink)` } as CSSProperties;
  return (
    <span className="painel-tag" data-tag={tag} style={estilo}>
      {TEXTO_DA_TAG[tag]}
    </span>
  );
}
